import React, {useEffect, useState} from 'react';

const Dashboard = () => {
    return (
        <div>
            <p>Dashboard page</p>
        </div>
    )
}

export default Dashboard;